import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { addNotification } from '@redux/features/notificationsSlice';

export const useForm = ({ initialValues, validationSchema, onSubmit, trimValues = true, status }) => {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, helpers) => {
      const processedValues = trimValues
        ? Object.fromEntries(Object.entries(values).map(([k, v]) => [k, typeof v === 'string' ? v.trim() : v]))
        : values;

      await onSubmit(processedValues, helpers);
    },
  });

  useEffect(() => {
    if (status?.error) {
      dispatch(
        addNotification({
          id: Date.now(),
          title: status.error,
          type: 'error',
        })
      );
    }
  }, [status?.error]);

  return {
    values: formik.values,
    errors: formik.errors,
    touched: formik.touched,
    handleChange: formik.handleChange,
    handleBlur: formik.handleBlur,
    handleSubmit: formik.handleSubmit,
    isSubmitting: formik.isSubmitting,
    isValid: formik.isValid,
    resetForm: formik.resetForm,
    setFieldValue: formik.setFieldValue,
  };
};
